// src/utils/fileUtils.js
const ipcRenderer = window.electronAPI ? window.electronAPI : null;

export const saveFile = async (filePath, content) => {
  return await ipcRenderer.invoke('save-file', { filePath, content });
};

export const readFile = async (filePath) => {
  return await ipcRenderer.invoke('read-file', filePath);
};

export const deleteFile = async (filePath) => {
  return await ipcRenderer.invoke('delete-file', filePath);
};

export const showSaveDialog = async () => {
  return await ipcRenderer.invoke('show-save-dialog');
};

export const showOpenDialog = async () => {
  return await ipcRenderer.invoke('show-open-dialog');
};